import { useForm } from 'react-hook-form';
import { Grid, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FormProvider, RHFTextField } from 'src/components/hook-form';

export default function GamePlaylistTableToolbar({ onChangePage, setFilterItems }) {
  const methods = useForm({});

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (values) => {
    const PAYLOAD = {
      AppID: -1,
      Title: values?.Title || '',
    };

    setFilterItems(PAYLOAD);
    onChangePage(null, 0);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: 'grid',
              columnGap: 2,
              rowGap: 3,
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
            }}
          >
            <RHFTextField name="Title" type="text" label="نام بازی" />

            <LoadingButton size="medium" type="submit" variant="contained" loading={isSubmitting} sx={{ height: '55px' }}>
              جستجو
            </LoadingButton>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
